<template>
  <v-app-bar color="primary" fixed dark app>
    <v-app-bar-nav-icon @click="handleDrawerToggle" />
    <v-text-field
      v-if="isShowElement(privileges, dataType.PrivilegeCode.CUSTOMER_SEARCH, dataType.PrivilegeType.WRITABLE)"
      flat
      solo-inverted
      label="Search customer using the SSN, Email, App #, Account # or Phone #"
      prepend-inner-icon="search"
      v-on:keyup.enter="searchCustomer"
      class="hidden-sm-and-down"
      v-model="condition"
      hide-details
      autocomplete="off"
      color="red"
      :loading="customerSearchLoading"
    ></v-text-field>
    <div v-if="isShowElement(privileges, dataType.PrivilegeCode.INSTANT_LITIGANT_VERIFICATION_STATUS, dataType.PrivilegeType.EXECUTABLE)">
      <template>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <span>
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                text
                style="background: #e69139"
                class="instant-litigant-verification-style"
              ><div class="instant">
                <div class="instant-text" :style="{color: '#e69139'}">ILV</div>
              </div>
              <div class="circle" :style="{background: ilv.color}"></div>
              </v-btn
              >
            </span>
        </template>
        <span>{{ ilv.tips }}</span>
      </v-tooltip>
      </template>
    </div>
    <v-spacer></v-spacer>
    <v-toolbar-items style="margin-right: -15px">
      <template v-if="tool.isNotEmpty(privileges)">
        <portfolio-card v-if="isShowElement(privileges, dataType.PrivilegeCode.IGNORE_PORTFOLIO, dataType.PrivilegeType.EXECUTABLE)"></portfolio-card>
        <single-portfolio-card v-else></single-portfolio-card>
      </template>
    </v-toolbar-items>
    <v-toolbar dense slot="extension" color="white" light>
      <v-icon>mdi-home</v-icon>
      <v-breadcrumbs :items="breadcrumbs" class="pa-3"></v-breadcrumbs>
      <v-spacer></v-spacer>
      <v-btn icon small color="black">
        <v-icon v-text="'mdi-arrow-left'" @click="handleGoBack" />
      </v-btn>
    </v-toolbar>
    <v-dialog v-model="dialog.searchCustomerDialog" max-width="70%" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Search Customer</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog.searchCustomerDialog = false" color="primary">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <arb-loan-list :loanData="complex" :title="complex.title" @hideDialog="hideDialog('CUSTOMER_SEARCH')"></arb-loan-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>
<script>
import { LoanOperationApi, OriginationBusinessApi, AuthApi } from '@/api/pandaria'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { Authentication, DataType, Tool, Popup } from '@/util/index'
import PortfolioCard from '@/components/widget/menu/PortfolioCard'
import SinglePortfolioCard from '@/components/widget/menu/SinglePortfolioCard'

const popup = new Popup()
const tool = new Tool()
export default {
  name: 'AppToolbar',
  components: {
    SinglePortfolioCard,
    PortfolioCard
  },
  props: {
    privileges: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dataType: DataType,
      tool: tool,
      condition: '',
      complex: {
        headers: LIST_TABLE_HEADER.searchCustomerDialogTable,
        items: [],
        title: 'searchCustomer'
      },
      basic: {
        dialog: false
      },
      dialog: {
        searchCustomerDialog: false
      },
      customerSearchLoading: false,
      select: {
        portfolioLogo: '',
        portfolioName: '',
        portfolioId: '',
        portfolioList: []
      },
      ilv: {
        color: '#83f306',
        tips: 'online',
        timer: null
      }
    }
  },
  computed: {
    breadcrumbs () {
      const items = [
        {
          text: 'Home',
          to: { path: '/welcome' }
        }
      ]
      if (['/', '/welcome'].includes(this.$route.path) === false) {
        items.push({
          text: this.$route.meta.title,
          to: { path: this.$route.path }
        })
      }
      return items
    }
  },
  methods: {
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    },
    handleDrawerToggle () {
      this.$eventBus.$emit('side-icon-click')
    },
    handleGoBack () {
      this.$router.go(-1)
    },
    hideDialog (value) {
      switch (value) {
        case 'CUSTOMER_SEARCH':
          this.dialog.searchCustomerDialog = false
          break
        default:
          break
      }
    },
    searchCustomer () {
      const $this = this
      let condition = $this.condition
      condition = condition.trim()
      if (tool.isEmpty(condition)) {
        popup.popupForWarning('Please input one condition then search again.')
        return
      }
      if (this.customerSearchLoading) {
        return
      }
      $this.customerSearchLoading = true
      const portfolioList = $this.store.getters.getAccount.portfolioIdList
      const params = {
        condition: condition,
        portfolioList: portfolioList
      }
      LoanOperationApi.customerSearch(params, function (result) {
        if (tool.isNotEmpty(result)) {
          window.localStorage.setItem('searchKey', params.condition)
        }
        $this.customerSearchLoading = false
        let displayData = []
        if (tool.isNotEmpty(result) && !$this.isShowElement(
          $this.privileges,
          $this.dataType.PrivilegeCode.CUSTOMER_SEARCH_CROSS_PORTFOLIO,
          $this.dataType.PrivilegeType.EXECUTABLE)) {
          for (const item of result) {
            if (portfolioList.indexOf(item.portfolioId) !== -1) {
              displayData.push(item)
            }
          }
        } else {
          displayData = result
        }
        if (displayData === undefined || JSON.stringify(displayData) === '[]') {
          popup.popupForWarning('No data found')
        } else {
          $this.dialog.searchCustomerDialog = true
          $this.complex.items = displayData
          $this.$forceUpdate()
        }
      },
      function (res) {
        $this.customerSearchLoading = false
        popup.popupForError(res.message)
      }
      )
    }
  },
  created () {
    const $this = this
    this.ilv.timer = setInterval(() => {
      setTimeout(() => {
        OriginationBusinessApi.getILVStatus(null, function (result) {
          if (parseInt(result) === DataType.ILVStatusEnum.ONLINE.value) {
            $this.ilv.color = '#83f306'
            $this.ilv.tips = DataType.ILVStatusEnum.ONLINE.text
          } else {
            $this.ilv.color = '#ee0b0b'
            $this.ilv.tips = DataType.ILVStatusEnum.OFF_LINE.text
          }
        })
        AuthApi.token(null, function (result) { },
          function (error) {
            if (error && error.code === -1) {
              $this.$router.push('/sign-in')
            } else {
              console.log(error.message)
            }
          })
      }, 0)
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.ilv.timer)
    this.ilv.timer = null
    console.log('destroyed timer')
  }
}
</script>

<style lang="sass" scoped>
  .user-content
    padding: 15px 10px 5px
  .user-content > div
    text-align: center
  .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot
    background: white!important
  .portfolio-title
    width: 300px
    height: 120%
    display: flex
    justify-content: center
    align-items: center
    padding: 5px 15px
    background-color: rgba(255, 255, 255, 0.27)
  .instant-litigant-verification-style
    position: relative
    width: 46px
    height: 46px
    line-height: 46px
    margin-left: 20px
  .instant
    width: 36px
    height: 36px
    border-radius: 50%
    background: #fff
  .instant-text
    margin-top: 10px
  .circle
    position: absolute
    width: 8px
    height: 8px
    border-radius: 50%
    top: 78%
    left: 78%
</style>
